import React, {Component} from 'react'
import {Button, Table, Popconfirm} from 'antd'
import {DeleteOutlined, VerticalAlignBottomOutlined, VerticalAlignTopOutlined} from '@ant-design/icons'
import {inject, observer} from 'mobx-react'
import {withTranslation} from 'react-i18next'

@inject('jobManagementStore')
@observer
class ExecuteTable extends Component {

  getRowClassName = (record, index) => {
    let className
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }

  render() {
    const {dataSource, onDelete, onUp, onDown, t} = this.props
    return (
      <Table dataSource={dataSource} pagination={false} rowClassName={this.getRowClassName}>
        <Table.Column width={80} title={t(`job.no`)} dataIndex="index"/>
        <Table.Column title={t(`job.inboundName`)} dataIndex="label" ellipsis/>
        <Table.Column width={150} align="center" title={t(`general.action`)} key="Action" render={(text, record, index) => {
          return (
            <>
              <Button type="link" onClick={() => onUp(index)} icon={<VerticalAlignTopOutlined/>}/>
              <Button type="link" onClick={() => onDown(index)} icon={<VerticalAlignBottomOutlined/>}/>
              <Popconfirm title={t(`general.sureToDelete`)} onConfirm={() => onDelete(index)}>
                <Button type="link" icon={<DeleteOutlined/>}/>
              </Popconfirm>
            </>
          )
        }}/>
      </Table>
    )
  }
}

export default withTranslation()(ExecuteTable)
